import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Article from './views/Article.vue';
import Expertise from './views/Expertise.vue';
import Portfolio from './views/Portfolio.vue';
import Static from './views/Static.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang([a-z]{2})?',
      name: 'home',
      component: Home,
      meta:{index:0},
    },
    {
      path: '/:lang([a-z]{2})?/expertises/:id',
      name: 'article',
      component: Article,
      meta:{index:1},
    },
    {
      path: '/:lang([a-z]{2})?/agence',
      name: 'expertise',
      component: Expertise,
      meta:{index:1},
    },
    {
      path: '/:lang([a-z]{2})?/expertises',
      name: 'portfolio',
      component: Portfolio,
      meta:{index:1},
    },
    {
      path: '/:lang([a-z]{2})?/rgpd',
      name: 'rgpd',
      component: Static,
      meta:{index:1, type: 'static'},
    },
    {
      path: '/:lang([a-z]{2})?/conditions-generales',
      name: 'conditions-generales',
      component: Static,
      meta:{index:1, type: 'static'},
    },
    {
      path: '/:lang([a-z]{2})?/mentions-legales',
      name: 'mentions-legales',
      component: Static,
      meta:{index:1, type: 'static'},
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.type === 'static' && from.meta.type === 'static') {
      return;
    }

    if (savedPosition) {
      return new Promise(() => {
        setTimeout(() => {
          window.scrollTo({ top: savedPosition.y, behavior: 'smooth' });
        }, 400)
      });
    } else {
      return window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },

});

router.beforeEach((to, from, next) => {
	if (from.params.lang && !to.params.lang) {
		next ({ path: `/${from.params.lang}${to.path}` });
	} else {
		next();
  }
});

export default router;